const colors = {
    background: '#F9F9F9',
    gray: '#EBEBF5',
    gray50: '#F2F4F7',
    gray80: '#E3E1E5',
    gray100: '#E4E7EC',
    gray100dot30: '#EBE9EC',
    gray200: '#D0D5DD',
    gray300: '#C0B9C4',
    gray400: '#CFCBD3',
    gray500: '#6D6473',
    gray600: '#71768F',
    gray800: '#4F4A55',
    gray900: '#344054',
    gray0: '#101828',
    grey800: '#4B4551',
    purple100: '#E1DEE4',
    purple200: '#D2CBD8',
    purple300: '#D6BBFB',
    purple500: '#68597A',
    purple600: '#6941C6',
    purple800: '#8E829B',
    purple1000: '#F4EBFF',
    fontDefaultColor: '#121A45',
    black: '#000000',
    clear: 'rgba(0,0,0,0)',
    transparent15: 'rgba(0,0,0,0.15)',
    transparent30: 'rgba(0,0,0,0.3)',
    transparent50: 'rgba(0,0,0,0.5)',
    whiteAlpha30: 'rgba(255,255,255,0.3)',
    whiteAlpha50: 'rgba(255,255,255,0.5)',
    grayAlpha30: 'rgba(228, 228, 228, 0.3)',
    grayAlpha60: 'rgba(228, 228, 228, 0.6)',
    snow: '#FFFFFF',
    error: '#D41F40',
    darkBlueAlpha12: '#2E31921F',
    darkBlackAlpha: 'rgba(0, 0, 0, 0.12)',
    purpleAlpha: 'rgba(104, 89, 122, 0.20)',
    overlay: 'rgba(75,69,81,0.7)',
};
export default colors;
export const theme = {
    colors: {
        brandPrimary: colors.purple500,
        brandSecondary: colors.purple100,
        textPrimary: colors.gray0,
        textSecondary: colors.purple600,
        textSecondary700: colors.gray900,
        borderPrimary: colors.gray200,
        borderSecondary: colors.gray100,
        borderTeriary: colors.purple300,
        borderSelected: colors.purple600,
        label: '#667085',
    },
};
